module.exports = __webpack_public_path__ + "a582a1af525ad1f8d1f275cfeced3bbc.jpg";